<button class="w-full h-full rounded-[14px] border-spacing-2 border-2 border-primary-500 border-dashed bg-primary-200 flex flex-col select-none"
    (click)="fileInput.click()" (dragover)="fileUploadHelper.onDragOver($event)"
    (drop)="fileUploadHelper.onDrop($event)" *ngIf="!isUploadActive() || !showListOfRecentUploadsAfterUpload">
    <input #fileInput type="file" accept=".pdf,.xls,.xlsx" (change)="fileUploadHelper.onFileSelected($event)"
        class="hidden" multiple>

    <div class="flex-1 flex flex-col justify-center items-center">
        <div class="w-[80px] h-[80px] flex items-center justify-center rounded-full text-white font-bold uppercase overflow-hidden">
        <img src="assets/icons/upload-circle.svg" width="60px" height="60px" alt="{{ 'shared.upload_icon' | transloco }}">
        </div>
    </div>

    <div class="flex-1 flex flex-col justify-center items-center px-4">
        <p class="text-center text-sm">
            <b>{{ 'shared.automatically_retrieve_location_data.automatically' | transloco }}</b>
            {{ 'shared.automatically_retrieve_location_data.retrieve_location' | transloco }}
            <b>{{ 'shared.automatically_retrieve_location_data.invoice' | transloco }}</b>
            {{ 'shared.automatically_retrieve_location_data.or' | transloco }}
            <b>{{ 'shared.automatically_retrieve_location_data.contract' | transloco }}</b>.
        </p>
    </div>

    <div class="flex-1 flex flex-col justify-center items-center">
        <div class="max-w-screen-sm w-11/12">
            <app-primary-button buttonText="{{ 'invoice.upload_file' | transloco }}" [isDisabled]="false"></app-primary-button>
        </div>
    </div>
</button>

<div *ngIf="isUploadActive() && showListOfRecentUploadsAfterUpload"
    class="flex flex-col w-full h-full rounded-[14px] border-border border-[1px] p-5 max-w-ultrawide">
    <ng-container *ngFor="let uploadInfo of listOfRecentUploads; let i = index">
        <app-uploaded-file [fileSrc]="uploadInfo.fileSrc" [fileName]="uploadInfo.fileName"
            [fileSize]="uploadInfo.fileSizeMB" [currentValue]="uploadInfo.currentUploadProgress"
            (stopClick)="stopClicked(i)" [canceled]="uploadInfo.canceled"></app-uploaded-file>
    </ng-container>
</div>